import { observer } from "mobx-react";
import LinkableList from "../../../components/linkable-list/linkable-list";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";
import { ICustomerRmasList } from "../../../services/api/customer-service";
import config from "../../../config";
import { RMA_QUICK_FILTERS } from "../../manage-returns/rma-list-page/stores/rma-paged-list-store";


interface IProps {
    isLoading: boolean;
    rmasList?: ICustomerRmasList;
    searchInput: string;
    noData?: string;
}

const RmasLinkableList: React.FC<IProps> = observer(({ isLoading, rmasList, noData, searchInput }) => {
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-returns-rma-card';
    /** do not render any information while we are still in process of fetching it */
    if (isLoading) {
        return null;
    }
    
    const totalCount = rmasList?.total_count;
    const list = totalCount === 1
        ? ([{ label: getTranslation('CURRENT_RMA', pageScope), href: ''}])
        : (rmasList?.list ?? []).map((item) => {
            return {label: item.id, href: config.apiUrl + '/dashboard/returns?rmaid=' + item.id}
          });
    const totalRemainingItemsLinkHref = totalCount && totalCount > 1
        ? config.apiUrl + '/dashboard/returns?search_input=' + encodeURIComponent(searchInput) + '&filter_status=' + RMA_QUICK_FILTERS.ALL
        : undefined;

    if (!list.length) {
        return <>{noData}</>;
    }

    return (
        <LinkableList
            totalCount={totalCount!}
            list={list}
            totalRemainingItemsLinkHref={totalRemainingItemsLinkHref}
            />
    );
});

export default RmasLinkableList